export default __webpack_public_path__ + "static/media/bazzle_v_4.1901a457.png";